import { useLazyUserLogin } from '@gef-ui/authorization-v2';
import { getErrorMessage, getErrorsMessages } from '@gef-ui/error-report-core/utils';
import { getLabelMessage } from '@gef-ui/localization/messages';
import Copy from '@gef-ui/material-icons/Copy';
import { versionPropTypes } from '@gef-ui/version-info-core/constants';
import Box from '@mui/material/Box';
import MuiButton from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { errorPropType } from '../../../constants';
import { useDefaultComponentValue } from '../../../utils';
const TOOLTIP_MS_TIMEOUT = 1500;
const CopyIcon = styled(Copy)(({ theme })=>({
        width: 20,
        height: 20,
        fill: theme.palette.common.white
    }));
const Button = styled(MuiButton)(({ theme })=>({
        backgroundColor: theme.palette.primary.main,
        [theme.breakpoints.down('md')]: {
            width: '100%'
        }
    }));
Button.defaultProps = {
    variant: 'contained'
};
const TooltipSeparator = styled(Box)(({ theme })=>({
        [theme.breakpoints.down('md')]: {
            width: '100%'
        }
    }));
const COMPONENT_NAME = 'MuiCopyButton';
const CopyButton = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { fe, be, error, errors, children, timestamp, noIcon, fullSize, ...other } = props;
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const getUser = useLazyUserLogin();
    const copyErrorToClipboard = async ()=>{
        await navigator.clipboard.writeText(errors ? getErrorsMessages(fe, be, errors, getUser(), timestamp) : getErrorMessage(fe, be, error, getUser(), timestamp));
        setIsTooltipVisible(true);
        setTimeout(()=>{
            if (!isTooltipVisible) {
                setIsTooltipVisible(false);
            }
        }, TOOLTIP_MS_TIMEOUT);
    };
    return /*#__PURE__*/ React.createElement(Tooltip, {
        placement: "top",
        title: getLabelMessage('common:provideDetailsInReport'),
        sx: (theme)=>({
                [theme.breakpoints.up('md')]: {
                    margin: fullSize ? theme.spacing(0, 'auto', 0, 0) : undefined
                }
            })
    }, /*#__PURE__*/ React.createElement(TooltipSeparator, null, /*#__PURE__*/ React.createElement(Tooltip, {
        placement: "bottom",
        title: getLabelMessage('common:copied'),
        open: isTooltipVisible
    }, /*#__PURE__*/ React.createElement(Button, {
        ...other,
        id: 'copy-error-button',
        startIcon: noIcon ? undefined : /*#__PURE__*/ React.createElement(CopyIcon, null),
        onClick: copyErrorToClipboard
    }, children))));
};
CopyButton.propTypes = {
    be: versionPropTypes,
    children: PropTypes.node,
    error: errorPropType,
    errors: PropTypes.arrayOf(errorPropType),
    fe: versionPropTypes,
    fullSize: PropTypes.bool,
    noIcon: PropTypes.bool,
    timestamp: PropTypes.string
};
export default CopyButton;
